
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"29","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 14.5C0 6.492 6.492 0 14.5 0S29 6.492 29 14.5C29 22.507 22.508 29 14.5 29S0 22.507 0 14.5","fill":"#FDBE52"}}),_c('path',{attrs:{"d":"M21.807 17H8.193C6.987 17 6 15.874 6 14.5c0-1.376.987-2.5 2.193-2.5h13.614C23.012 12 24 13.124 24 14.5c0 1.374-.988 2.5-2.193 2.5","fill":"#FFF"}})])])
          )
        }
      }
    